import React from "react";

// Short labels so the badge doesn't blow up the row.
const PACKAGE_SHORT = {
  "Mentorship": "Mentorship",
  "Year Long Tier 1": "YL Tier 1",
  "Year Long Tier 2": "YL Tier 2",
  "Year Long Custom": "YL Custom",
  "The Program Platinum": "Platinum",
};

// Two axes: package name defines base color, status modifies intensity/border.
const PACKAGE_COLORS = {
  "Mentorship":          { fg: "#60a5fa", bg: "rgba(96,165,250,0.15)",  border: "rgba(96,165,250,0.5)"  },
  "Year Long Tier 1":    { fg: "#f9d451", bg: "rgba(249,212,81,0.15)",  border: "rgba(249,212,81,0.5)"  },
  "Year Long Tier 2":    { fg: "#c084fc", bg: "rgba(192,132,252,0.15)", border: "rgba(192,132,252,0.5)" },
  "Year Long Custom":    { fg: "#fb923c", bg: "rgba(251,146,60,0.15)",  border: "rgba(251,146,60,0.5)"  },
  "The Program Platinum":{ fg: "#e5e7eb", bg: "rgba(229,231,235,0.15)", border: "rgba(229,231,235,0.6)" },
};

export default function PackageBadge({ name, status, testId }) {
  if (!name) return null;
  const label = PACKAGE_SHORT[name] || name;
  const c = PACKAGE_COLORS[name] || { fg: "#a0a0a0", bg: "rgba(255,255,255,0.08)", border: "rgba(255,255,255,0.2)" };

  const isPaused = status === "Paused";
  const isEnded  = status === "Ended";

  const style = {
    color: (isPaused || isEnded) ? "#a0a0a0" : c.fg,
    background: (isPaused || isEnded) ? "transparent" : c.bg,
    borderColor: (isPaused || isEnded) ? "rgba(255,255,255,0.15)" : c.border,
    opacity: isEnded ? 0.55 : 1,
    textDecoration: isEnded ? "line-through" : "none",
  };

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 border text-[9px] uppercase tracking-[0.2em] font-bold whitespace-nowrap"
      style={style}
      title={status ? `${name} · ${status}` : name}
      data-testid={testId}
    >
      {!isEnded && !isPaused && (
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: c.fg, boxShadow: `0 0 6px ${c.fg}` }}
        />
      )}
      {isPaused && <span className="w-1.5 h-1.5 rounded-full bg-amber-400" />}
      {label}
    </span>
  );
}
